import { TableBodyCell, breakpoints } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const DesktopTableBodyCell = styled(TableBodyCell) `
  ${breakpoints.xs} {
    display: none;
  }
`;
